<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>I would like to thank my husband for his support throughout this book and the first. I would also like to thank my children for their ongoing support and everyone who has encouraged me. Without them, this book would not have happened. I would like to thank Maska, the dog, who inspired me to build one of the characters on. I would like to thank David Pearce for his magic of the front cover and all the amazing pictures inside this book.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?1ce45297